import { BaseLookupModel, PaginationFilterRequest } from "./core.model";

export interface EncyclopediaRelation {
  id: number;
  encyclopediaItemId: number;
  storyChapterId: number;
  unlockAtChapterStart: boolean;

  encyclopediaItem: BaseLookupModel;
  storyChapter: BaseLookupModel;
}

export interface UpsertEncyclopediaRelation {
  id?: number;
  encyclopediaItemId?: number;
  storyChapterId?: number;
  unlockAtChapterStart?: boolean;
}

export class EncyclopediaRelationPaginationFilterRequest extends PaginationFilterRequest{  
  storyId?: number;
  storyChapterId?: number;
  encyclopediaItemId?: number;
  onlyUnlockAtChapterStart?: boolean;
  onlyUnlockAtChapterEnd?: boolean;
}

